// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"50b458d0","158":"31c30520","173":"c16d27d3","357":"9afa5513","389":"4c2abfd2","453":"7d8792e8","459":"142797a0","531":"52ca7613","619":"2866c4bf","694":"421b2915","824":"8e191d1d","841":"fd2855be","850":"b0eed5ca","907":"1b50e079"}[chunkId] + ".chunk.js";
};